module.exports = __webpack_public_path__ + "media/warning.04928972.wav";